import React, { useState } from "react";
import PhoneInput from "react-phone-input-2";
import DatePicker from "react-datepicker";
import "react-phone-input-2/lib/style.css";
import "react-datepicker/dist/react-datepicker.css";
import { format, parse } from "date-fns";
import { getFontsStyles } from "../../../../modules/TrayModules/Helper/helper";

const CheckoutFormInputs = ({
  isCheckoutScreen,
  formType,
  hideMobileNumber,
  metadataMap,
  checkoutInputBgColor,
  checkoutInputColor,
  areacode,
  handleOnChange,
  handleValidateOnEvent,
  handleValidateOnBlur,
  handleVerified,
  verifiedValue,
  userExist,
  errMsg,
  successMsg,
  greenTick,
  checkoutLayoutSettings,
  formInputData,
  handleGameOnBlur,
  handleValueChange,
  checkoutModuleData,
  dobFormat = "MM-dd-yyyy",
}) => {
  if (!isCheckoutScreen) return null;

  const primaryCategory = checkoutLayoutSettings?.primaryField || "both";

  const formatDOBValue = (dobStr) => {
    if (!dobStr) return null;
    try {
      return parse(dobStr, dobFormat, new Date());
    } catch {
      return null;
    }
  };

  const {loginV2Title} = getFontsStyles(checkoutModuleData?.moduleData?.layout?.fontSetting)

  const requiredText = metadataMap?.requiredText || "";
  const optionalText = metadataMap?.optionalText || "";


  return (
    <div className="checkout-form-data">
      <div className="inputForm user-details">
        <label style={{ color: checkoutLayoutSettings?.sectionTextColor, fontFamily: loginV2Title?.fontFamily, fontSize:loginV2Title?.fontSize  }}>
          {metadataMap?.primaryLabelText}
        </label>
        {(primaryCategory === "mobile") ? (
          <div className="phone-and-email-input">
            <PhoneInput
              containerClass="reactInputTel"
              country={window.app_data.countryCode?.toLowerCase()}
              value={areacode}
              onChange={handleOnChange}
            />
            <input
              className={errMsg.type === "email" ? "getVerified-Email mobile-gap errBorder" : "getVerified-Email mobile-gap"}
              style={{ background: checkoutInputBgColor, color: checkoutInputColor }}
              value={verifiedValue}
              name="username"
              autoComplete="username"
              onKeyDown={handleValidateOnEvent}
              onBlur={(e) => verifiedValue.length > 0 && handleValidateOnBlur(e)}
              onChange={handleVerified}
              placeholder={metadataMap?.phoneNumberPlaceholderText || "Enter your Phone Number"}
              disabled={userExist}
              autoFocus
              data-test="email-field"
            />
          </div>
        ) : (primaryCategory === "email") ? (
          <input
            className={`getVerified-Email${errMsg.type === "email" ? " errBorder" : ""}`}
            style={{ background: checkoutInputBgColor, color: checkoutInputColor }}
            value={verifiedValue}
            name="username"
            autoComplete="username"
            onKeyDown={handleValidateOnEvent}
            onBlur={(e) => verifiedValue.length > 0 && handleValidateOnBlur(e)}
            onChange={handleVerified}
            placeholder={metadataMap?.emailAddressPlaceholderText || "Enter your email"}
            disabled={userExist}
            autoFocus
            data-test="email-field"
          />
        ) : <div className="phone-and-email-input">
          {formType.category == "mobile" ? (
            <PhoneInput
              containerClass="reactInputTel"
              country={window.app_data.countryCode?.toLowerCase()}
              value={areacode}
              onChange={handleOnChange}
            />
          ) : (
            false
          )}
          <input
            className={formType.category === "mobile" && !hideMobileNumber ? errMsg.type === "email" ? "getVerified-mobile errBorder" : "getVerified-mobile" : errMsg.type === "email" ? "getVerified-Email errBorder" : "getVerified-Email"}
            style={!isCheckoutScreen ? { background: inputColor, fontFamily: fontStyles?.loginV2InputBoxPlaceholder?.fontFamily, fontSize: fontStyles?.loginV2InputBoxPlaceholder?.fontSize } : { background: checkoutInputBgColor, color: checkoutInputColor }}
            value={verifiedValue}
            name="username"
            autocomplete="username"
            onKeyDown={handleValidateOnEvent}
            onBlur={(e) => isCheckoutScreen && verifiedValue.length > 0 && handleValidateOnBlur(e)}
            onChange={(e) => handleVerified(e)}
            placeholder={metadataMap?.emailTextFieldPlaceHolder || "Enter your email or phone number"}
            disabled={userExist}
            autoFocus
            data-test="email-field"
          />
        </div>}

        {successMsg && (
          <div className="successMessage site-cta-color" data-test="email-vertfied">
            {greenTick()}
          </div>
        )}
      </div>
      {checkoutLayoutSettings?.showSecondaryField && (
        <div className="inputForm user-details">
          <label style={{ color: checkoutLayoutSettings?.sectionTextColor, fontFamily: loginV2Title?.fontFamily, fontSize:loginV2Title?.fontSize  }}>
            {
              primaryCategory === "email" ? `${metadataMap?.phoneLabelText || "Phone"} ${checkoutLayoutSettings?.isSecondaryFieldRequired ? requiredText : optionalText}` : primaryCategory === "mobile" ? `${metadataMap?.emailLabelText || "Email"} ${checkoutLayoutSettings?.isSecondaryFieldRequired ? requiredText : optionalText}` : formType.category !== "mobile"
                ? `${metadataMap?.phoneLabelText || "Phone"} ${checkoutLayoutSettings?.isSecondaryFieldRequired ? requiredText : optionalText}`
                : `${metadataMap?.emailLabelText || "Email"} ${checkoutLayoutSettings?.isSecondaryFieldRequired ? requiredText : optionalText}`
            }
          </label>

          <div className="phone-and-email-input">
            {primaryCategory === "email" ? <>
              <PhoneInput
                containerClass="reactInputTel"
                country={window.app_data.countryCode?.toLowerCase()}
                value={areacode}
                onChange={handleOnChange}
              />
              <input
                className={errMsg.type === "phone" ? "getVerified-Email mobile-gap errBorder" : "getVerified-Email mobile-gap"}
                style={{ background: checkoutInputBgColor, color: checkoutInputColor }}
                value={formInputData?.phone}
                name="phone"
                onBlur={(e) => handleGameOnBlur(e, "phone")}
                onChange={handleValueChange}
                placeholder={metadataMap?.phoneNumberPlaceholderText || "Enter your Phone Number"}
                disabled={userExist}
                data-test="phone-field"
                type="tel"
              />
            </> : primaryCategory === "mobile" ? (
              <input
                className={errMsg.type === "phone" ? "getVerified-Email errBorder" : "getVerified-Email"}
                style={{ background: checkoutInputBgColor, color: checkoutInputColor }}
                value={formInputData?.phone}
                name="phone"
                onBlur={(e) => handleGameOnBlur(e, "phone")}
                onChange={handleValueChange}
                placeholder={metadataMap?.emailAddressPlaceholderText || "Enter your email"}
                disabled={userExist}
                data-test="email-field"
                type="email"
              />
              ) : (
                <>
                  {
                    formType.category === "mobile" ? (
                      <input
                        className={errMsg.type === "phone" ? "getVerified-Email errBorder" : "getVerified-Email"}
                        style={{ background: checkoutInputBgColor, color: checkoutInputColor }}
                        value={formInputData?.phone}
                        name="phone"
                        onBlur={(e) => handleGameOnBlur(e, "phone")}
                        onChange={handleValueChange}
                        placeholder={metadataMap?.emailAddressPlaceholderText || "Enter your email"}
                        disabled={userExist}
                        data-test="email-field"
                        type="email"
                      />
                    ) : (
                      <>
                        <PhoneInput
                          containerClass="reactInputTel"
                          country={window.app_data.countryCode?.toLowerCase()}
                          value={areacode}
                          onChange={handleOnChange}
                        />
                        <input
                          className={errMsg.type === "phone" ? "getVerified-Email mobile-gap errBorder" : "getVerified-Email mobile-gap"}
                          style={{ background: checkoutInputBgColor, color: checkoutInputColor }}
                          value={formInputData?.phone}
                          name="phone"
                          onBlur={(e) => handleGameOnBlur(e, "phone")}
                          onChange={handleValueChange}
                          placeholder={metadataMap?.phoneNumberPlaceholderText || "Enter your Phone Number"}
                          disabled={userExist}
                          data-test="phone-field"
                          type="tel"
                        />
                      </>
                    )
                  }
                </>
              )}
          </div>
        </div>
      )}

      {checkoutLayoutSettings?.showName && (
        <div className="inputForm user-details">
          <label style={{ color: checkoutLayoutSettings?.sectionTextColor, fontFamily: loginV2Title?.fontFamily, fontSize:loginV2Title?.fontSize  }}>
            {metadataMap?.nameLabelText || "Name"}{" "}
            {checkoutLayoutSettings?.isNameRequired ? requiredText : optionalText}
          </label>
          <input
            className={`getVerified-Email ${errMsg.type === "name" ? "errBorder" : ""}`}
            style={{ background: checkoutInputBgColor, color: checkoutInputColor }}
            value={formInputData?.name}
            name="name"
            onBlur={(e) => handleGameOnBlur(e, "name")}
            onChange={handleValueChange}
            placeholder={metadataMap?.namePlaceholderText || "Enter your Full Name"}
            disabled={userExist}
            data-test="name-field"
          />
        </div>
      )}

      {checkoutLayoutSettings?.showDOB && (
        <div className="inputForm user-details">
          <label style={{ color: checkoutLayoutSettings?.sectionTextColor, fontFamily: loginV2Title?.fontFamily, fontSize:loginV2Title?.fontSize  }}>
            {metadataMap?.dobLabelText || "DOB"}{" "}
            {checkoutLayoutSettings?.isDOBRequired ? requiredText : optionalText}
          </label>
          <DatePicker
            selected={formatDOBValue(formInputData.dob)}
            onChange={(date) =>
              handleValueChange({
                target: { name: "dob", value: format(date, dobFormat) },
              })
            }
            showMonthDropdown
            showYearDropdown
            dropdownMode="select"
            maxDate={new Date()} 
            onCalendarClose={() => {
            const fakeEvent = {
              target: {
                name: 'dob',
                value: formInputData.dob, 
              }
            };
            handleGameOnBlur(fakeEvent, 'dob');
            }}
            placeholderText={metadataMap?.dobPlaceholderText || "MM-DD-YYYY"}
            customInput={
              <input
               
                style={{ background: checkoutInputBgColor, color: checkoutInputColor }}
                className={`getVerified-Email ${errMsg.type === "dob" ? "errBorder" : ""}`}
                name="dob"
                data-test="dob-field"
                disabled={userExist}
              />
            }
          />
        </div>
      )}

      {checkoutLayoutSettings?.showZipCode && (
        <div className="inputForm user-details">
          <label style={{ color: checkoutLayoutSettings?.sectionTextColor, fontFamily: loginV2Title?.fontFamily, fontSize:loginV2Title?.fontSize  }}>
            {metadataMap?.zipCodeLabelText || "Zipcode"}{" "}
            {checkoutLayoutSettings?.isZipCodeRequired ? requiredText : optionalText}
          </label>
          <input
            className={`getVerified-Email ${errMsg.type === "zipCode" ? "errBorder" : ""}`}
            style={{ background: checkoutInputBgColor, color: checkoutInputColor }}
            value={formInputData.zipCode}
            name="zipCode"
            onBlur={(e) => handleGameOnBlur(e, "zipCode")}
            onChange={handleValueChange}
            placeholder={metadataMap?.zipCodePlaceholderText || "Enter Your Zipcode"}
            disabled={userExist}
            data-test="zipcode-field"
          />
        </div>
      )}
    </div>
  );
};

export default CheckoutFormInputs;
